import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  plansLength: 0,
  plans: [],
  plan: {},
  planError: "",
  formPlanError: "",
};

export default function PlanReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_PLAN:      
      return { ...state, loading: action.payload };

    case actions.LOADING_PLAN_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_PLAN:
      return { ...state, saveLoading: action.payload };

    case actions.GET_PLAN:
      return {
        ...state,
        plans: action.payload.plans,
        plansLength: action.payload.plansLength,
      };

    case actions.GET_PLAN_BY_ID:
      return { ...state, plan: action.payload };

    case actions.FORM_PLAN_FAIL:
      return { ...state, formPlanError: action.payload };

    case actions.PLAN_FAIL:
      return { ...state, planError: action.payload };

    default:
      return state;
  }
}
